'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.permission.service
 * @description
 * # permission.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('permissionService', function(BaseService, errorService, eventsService) {

    var service = new BaseService();
    var permissions = [];
    var promise = false;

    service.Permissions = getPermissions;
    service.clearPermissions = clearPermissions;
    service.hasPermission = hasPermission;
    service.permissionsLoaded = permissionsLoaded;


    return service;

    function clearPermissions() {
      permissions = [];
    }

    function getPermissions() {
      return !!permissions && !!permissions.length ? service.q.resolve(permissions) : fetchPermissions();
    }

    function hasPermission(permission) {
      if (angular.isArray(permission)) {
        return !!permissions && hasPermissions(permission);
      }
      return !!permissions && permissions.indexOf(permission) > -1;
    }

    function fetchPermissions() {
      promise = !!promise ?
        promise :
        service.http.get(service.baseUrl + '/claims/permissions/me')
        .then(handleSuccess)
        .catch(handleError)
        .finally(function() {
          promise = null;
        });

      return promise;
    }

    function permissionsLoaded() {
      return !!permissions && permissions.length;
    }

    function hasPermissions(arr) {
      return arr.some(function(item) {
        return permissions.indexOf(item) >= 0;
      });
    }

    function handleSuccess(response) {
      permissions = response.data;
      promise = null;
      eventsService.permissionsChanged();
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }

    function fetchInProgress() {
      return !!promise;
    }
  });
